import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logoUrl from '../../assets/logo-color.svg';

const Navbar: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [logoHidden, setLogoHidden] = useState(false);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return (
    <>
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-50 focus:rounded-md focus:bg-white focus:px-3 focus:py-2 focus:text-sedra focus:shadow">
        Skip to content
      </a>
      <header className="sticky top-0 z-40 bg-white/70 backdrop-blur supports-[backdrop-filter]:bg-white/60 border-b border-gray-100">
        <nav className="mx-auto max-w-7xl px-6 lg:px-8 py-4 flex items-center justify-between" aria-label="Global">
          <div className="flex items-center gap-3">
            <Link to="/" aria-label="Sedra" className="flex items-center gap-2">
              <img
                src={logoUrl}
                alt=""
                aria-hidden="true"
                className={logoHidden ? 'hidden' : 'h-6 w-auto'}
                onError={() => setLogoHidden(true)}
              />
              {logoHidden && (
                <span className="text-base font-semibold text-gray-900">Sedra</span>
              )}
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/features" className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors">Features</Link>
            <Link to="/pricing" className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors">Pricing</Link>
            <a href="#" className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors" rel="noopener noreferrer">Docs</a>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/login"
              className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors"
            >
              Sign in
            </Link>
            <Link
              to="/custportal/login"
              className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors"
            >
              Customer Portal
            </Link>
            <Link
              to="/register"
              className="inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold text-white bg-sedra hover:bg-sedra-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sedra transition-colors"
            >
              Get Started
            </Link>
          </div>

          {/* Mobile button */}
          <div className="md:hidden">
            <button
              type="button"
              onClick={() => setOpen(v => !v)}
              aria-controls="mobile-nav"
              aria-expanded={open}
              aria-label={open ? 'Close menu' : 'Open menu'}
              className="inline-flex items-center justify-center rounded-md p-2 text-gray-700 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sedra"
            >
              {open ? (
                // X icon
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6"><path fillRule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clipRule="evenodd"/></svg>
              ) : (
                // Hamburger
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6"><path fillRule="evenodd" d="M3.75 5.25A.75.75 0 0 1 4.5 4.5h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75Zm0 7.5a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75Zm0 7.5a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75Z" clipRule="evenodd"/></svg>
              )}
            </button>
          </div>
        </nav>

        {/* Mobile panel */}
        {open && (
          <div id="mobile-nav" className="md:hidden absolute inset-x-0 top-full bg-white border-b border-gray-100 shadow-sm">
            <div className="py-2">
              <Link to="/features" className="block px-6 py-3 text-gray-700 hover:bg-gray-50" onClick={() => setOpen(false)}>Features</Link>
              <Link to="/pricing" className="block px-6 py-3 text-gray-700 hover:bg-gray-50" onClick={() => setOpen(false)}>Pricing</Link>
              <a href="#" className="block px-6 py-3 text-gray-700 hover:bg-gray-50" rel="noopener noreferrer">Docs</a>
              <Link to="/custportal/login" className="block px-6 py-3 text-gray-700 hover:bg-gray-50" onClick={() => setOpen(false)}>Customer Portal</Link>
              <Link to="/login" className="block px-6 py-3 text-gray-700 hover:bg-gray-50">Sign in</Link>
              <div className="px-6 py-3">
                <Link
                  to="/register"
                  className="inline-flex w-full items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold text-white bg-sedra hover:bg-sedra-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sedra transition-colors"
                  onClick={() => setOpen(false)}
                >
                  Get Started
                </Link>
              </div>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Navbar; 